import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'receive-data',
    templateUrl: '../../templates/partials/receiveData-bill.html'
})

export class ReceiveDataBillComponent implements OnInit {

    @Input() receiveData;
    constructor(private router: Router) { }

    public goToUser(id: string) {
        this.router.navigate(['/users', id]);
    }

    ngOnInit() { }
}


// WEBPACK FOOTER //
// ./src/app/modules/bills/components/dummy/receiveData-bill.component.ts